<template>
	<div class="AccountSetupV2">
		<div class="contents">
			<h2>Account Setup</h2>
			<div class="main-section">
				<div class="inner-div">
					<h4 class="flex-text-with-icon">
						<span
							v-if="upload_setup_user_account_visible"
							style="align-item:center;"
						>
							<i class="el-icon-circle-check file-green-icon" />
						</span>
						<span v-else style="align-item:center;">
							<i class="el-icon-circle-check file-grey-icon" />
						</span>
						<span>Setup User Accounts</span>
					</h4>
					<div class="file-select-section">
						<button class="start">
							<label>
								Start
								<img src="../../assets/images/AccountSetup/right-arrow1.png" />
								<!-- <label>Start <span style="font-size:20px">➔</span> -->
								<input
									id="setupuseraccounts"
									ref="file1"
									type="file"
									name="File Upload"
									accept=".csv"
									class="csv-file-style"
									@change="getCsvFileName($event, 'Setup User Accounts')"
								/>
							</label>
							<!-- <img src="../../assets/images/AccountSetup/right-arrow.png"> -->
						</button>
					</div>
				</div>
				<div class="inner-div">
					<h4 class="flex-text-with-icon">
						<span v-if="upload_past_sales_visible">
							<i class="el-icon-circle-check file-green-icon" />
						</span>
						<span v-else>
							<i class="el-icon-circle-check file-grey-icon" />
						</span>
						Past Sales Data
					</h4>
					<div class="file-select-section">
						<button class="start">
							<label>
								Start
								<img src="../../assets/images/AccountSetup/right-arrow1.png" />
								<input
									id="pastSalesData"
									ref="file2"
									type="file"
									name="File Upload"
									accept=".csv"
									class="csv-file-style"
									@click="deleteCsvFile"
									@change="getCsvFileName($event, 'Upload Past Sales Data')"
								/>
							</label>
						</button>
					</div>
				</div>
				<div class="inner-div">
					<h4 class="flex-text-with-icon">
						<span>
							<i class="el-icon-circle-check file-grey-icon" />
						</span>
						Upload Planned Events
					</h4>
					<div class="file-select-section">
						<button class="start">
							<label>
								Start
								<img src="../../assets/images/AccountSetup/right-arrow1.png" />
								<input
									id="txtFileUpload"
									ref="file3"
									type="file"
									name="File Upload"
									accept=".csv"
									class="csv-file-style"
									@change="getCsvFileName($event, upload_user_information)"
								/>
							</label>
						</button>
					</div>
				</div>
				<div class="inner-div">
					<h4 class="flex-text-with-icon">
						<span>
							<i class="el-icon-circle-check file-grey-icon" />
						</span>
						Add Current Inventory
					</h4>
					<div class="file-select-section">
						<button class="start">
							<label>
								Start
								<img src="../../assets/images/AccountSetup/right-arrow1.png" />
								<input
									id="txtFileUpload"
									ref="file4"
									type="file"
									name="File Upload"
									accept=".csv"
									class="csv-file-style"
									@change="getCsvFileName($event, upload_user_information)"
								/>
							</label>
						</button>
					</div>
				</div>
				<div class="inner-div">
					<h4 class="flex-text-with-icon">
						<span v-if="upload_art_master_visible">
							<i class="el-icon-circle-check file-green-icon" />
						</span>
						<span v-else>
							<i class="el-icon-circle-check file-grey-icon" />
						</span>
						Upload Item Master / Article Database
					</h4>
					<div class="file-select-section">
						<button class="start">
							<label>
								Start
								<img src="../../assets/images/AccountSetup/right-arrow1.png" />
								<input
									id="uploadArticleMasterFile"
									ref="file5"
									type="file"
									name="File Upload"
									accept=".csv"
									class="csv-file-style"
									@change="getCsvFileName($event, 'Upload Article Master File')"
								/>
							</label>
						</button>
					</div>
				</div>
				<div class="inner-div">
					<h4 class="flex-text-with-icon">
						<span v-if="upload_BOM_visible">
							<i class="el-icon-circle-check file-green-icon" />
						</span>
						<span v-else>
							<i class="el-icon-circle-check file-grey-icon" />
						</span>
						Bill of Material / Recipe Build
					</h4>
					<div class="file-select-section">
						<button class="start">
							<label>
								Start
								<img src="../../assets/images/AccountSetup/right-arrow1.png" />
								<input
									id="BOM"
									ref="file6"
									type="file"
									name="File Upload"
									accept=".csv"
									class="csv-file-style"
									@change="getCsvFileName($event, 'BOM')"
								/>
							</label>
						</button>
					</div>
				</div>
			</div>
			<!-- <button @click="submitCSVFile">Submit</button> -->
		</div>
		<!-- table for displaying errors in csv file -->
		<el-dialog
			:visible.sync="dialogVisible"
			:fullscreen="true"
			:before-close="closeTableDialog"
		>
			<h3 class="text-center py-4 text-2xl">
				Please correct the errors marked in light red color
			</h3>
			<table v-for="(data, index) in tableData" :key="index" class="tableMain">
				<thead>
					<tr>
						<th
							v-for="(heading, index2) in data.headings[0]"
							:key="index2"
							class="text-xs"
							:class="{ 'border-left': index2 == 4 }"
						>
							{{ heading }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, index3) in data.rows" :key="index3">
						<td
							v-for="(element, index4) in row"
							:key="index4"
							:class="{ 'bg-red-lighter': element.isError || element.color }"
						>
							{{ element.value ? element.value : "-" }}
						</td>
					</tr>
				</tbody>
			</table>
		</el-dialog>
	</div>
</template>

<script>
import Papa from "papaparse";
import jsonSize from "json-size";
import Headings from "../../utils/csvHeadings.utils";
import csvService from "../../services/csvService";
export default {
	name: "AccountSetupV2",
	mixins: [],
	props: [],
	data() {
		return {
			upload_user_information: "Upload User Information",
			past_sales_data: "",
			planned_events: "Planned Events",
			upload_inventory: "Upload Inventory",
			upload_article_master_file: "",
			upload_BOM_file: "",
			setup_user_account: "",
			dataToShowInTable: {
				data: {
					headings: [],
					rows: []
				}
			},
			userInformation: "",
			dialogVisible: false,
			duplicate_row_results: [],
			check_duplicate_data: true,
			check_error_results: false,
			upload_setup_user_account_visible: false,
			upload_past_sales_visible: false,
			upload_art_master_visible: false,
			upload_BOM_visible: false,
			setup_user_account_file: "",
			past_sales_file: "",
			article_master_file: "",
			BOM_file: "",
			current_open_file: "",
			setup_account_csv_file: "",
			past_sales_csv_file: "",
			article_master_csv_file: "",
			bom_csv_file: "",
			errorsInCsv: [],
			articleCodeUniqueValueCheck: {},
			CategoryCheckInAM: {
				empty: false,
				full: false
			},
			SubCategoryCheckInAM: {
				empty: false,
				full: false
			}
		};
	},
	computed: {
		tableData() {
			return this.dataToShowInTable;
		}
	},
	created() {},
	mounted() {
		String.prototype.hashCode = function() {
			var hash = 0,
				i = 0,
				len = this.length;
			while (i < len) {
				hash = ((hash << 5) - hash + this.charCodeAt(i++)) << 0;
			}
			return hash;
		};
	},
	methods: {
		find_duplicate_in_array(arra1, position) {
			var object = {};

			arra1.forEach(function(data) {
				if (data.length > 0) {
					if (!object[data[position].value]) object[data[position].value] = 0;
					object[data[position].value] += 1;
				}
			});

			for (var prop in object) {
				if (object[prop] >= 2) {
					this.duplicate_row_results.push(prop);
				}
			}

			if (this.duplicate_row_results.length) {
				for (var j in this.duplicate_row_results) {
					for (var i in this.tableData.data.rows) {
						if (
							this.tableData.data.rows[i].length &&
							this.tableData.data.rows[i][position].value != null
						) {
							if (
								(this.tableData.data.rows[i].length &&
									this.tableData.data.rows[i][position].value) ==
								this.duplicate_row_results[j]
							) {
								this.tableData.data.rows[i][position].color = true;
							}
						}
					}
				}
			} else {
				this.check_duplicate_data = false;
			}
		},
		closeTableDialog() {
			this.dialogVisible = false;
			if (this.current_open_file == "Setup User Accounts") {
				this.setup_user_account_file = "";
			}
			if (this.current_open_file == "Upload Past Sales Data") {
				this.past_sales_file = "";
			}
			if (this.current_open_file == "Upload Article Master File") {
				this.article_master_file = "";
			}
			if (this.current_open_file == "BOM") {
				this.BOM_file = "";
			}
			this.dataToShowInTable = {
				data: {
					headings: [],
					rows: []
				}
			};
			// this.article_master_file = "";
		},
		deleteCsvFile(event) {
			// event.target.value = "";
			// console.log("event in deltercsvfile", event.target.value);
		},
		getCsvFileName(event, buttonName) {
			if (buttonName == "Setup User Accounts") {
				this.setup_user_account_file = this.$refs.file1.files[0];
				console.log(
					"this.setup_user_account_file",
					this.setup_user_account_file
				);
				this.handleFileSelect(event.target.files[0], "Setup User Accounts");
				var uploadSetupUserAccountFileData = document.getElementById(
					"setupuseraccounts"
				);
				uploadSetupUserAccountFileData.onclick = function() {
					this.value = null;
				};
				uploadSetupUserAccountFileData.onchange = function() {
					this.dataToShowInTable = {
						data: {
							headings: [],
							rows: []
						}
					};
					console.log("inside onchange bom");
				}.bind(this);
			}
			if (buttonName == "Upload Past Sales Data") {
				this.past_sales_file = this.$refs.file2.files[0];
				console.log("this.article_master_file", this.past_sales_file);
				this.handleFileSelect(event.target.files[0], "Upload Past Sales Data");
				var uploadPastSalesFileData = document.getElementById("pastSalesData");
				uploadPastSalesFileData.onclick = function() {
					this.value = null;
				};
				uploadPastSalesFileData.onchange = function() {
					this.dataToShowInTable = {
						data: {
							headings: [],
							rows: []
						}
					};
					console.log("inside onchange bom");
				}.bind(this);
			}

			if (buttonName == "Upload Article Master File") {
				this.article_master_file = this.$refs.file5.files[0];
				console.log("this.article_master_file", this.article_master_file);
				this.handleFileSelect(
					event.target.files[0],
					"Upload Article Master File"
				);
				var uploadArticleMasterFileData = document.getElementById(
					"uploadArticleMasterFile"
				);
				uploadArticleMasterFileData.onclick = function() {
					this.value = null;
				};
				uploadArticleMasterFileData.onchange = function() {
					this.dataToShowInTable = {
						data: {
							headings: [],
							rows: []
						}
					};
					console.log("inside onchange bom");
				}.bind(this);
			}

			if (buttonName == "BOM") {
				this.BOM_file = this.$refs.file6.files[0];
				console.log("this.article_master_file", this.BOM_file);
				this.handleFileSelect(event.target.files[0], "BOM");
				var uploadBOMFileData = document.getElementById("BOM");
				uploadBOMFileData.onclick = function() {
					this.value = null;
				};
				uploadBOMFileData.onchange = function() {
					this.dataToShowInTable = {
						data: {
							headings: [],
							rows: []
						}
					};
					console.log("inside onchange bom");
				}.bind(this);
			}
		},
		handleFileSelect(file, csvName) {
			// parse csv file data into json object and
			// send the data to validate to check if
			//there are any errors
			Papa.LocalChunkSize = 2000000;
			Papa.parse(file, {
				header: true,
				dynamicTyping: true,
				skipEmptyLines: true,
				// beforeFirstChunk: function(chunk) {
				// 	var index = chunk.match(/\r\n|\r|\n/).index;
				// 	var headings = chunk.substr(0, index).split(",");
				// 	console.log(headings.join() + chunk.substr(index));
				// 	// console.log("beforeFirstChunk", JSON.parse(JSON.stringify(chunk)));
				// 	return chunk;
				// },
				chunk: function(chunk, parser) {
					// console.log(jsonSize(chunk)); //=> 13
					console.log("chunk", chunk);
					// if (!parser.paused()) {
					// 	parser.pause();
					// }
					this.processCsvData(chunk, csvName);
					// this.doStuff(chunk, parser);
					// setTimeout(() => {
					// 	if (parser.paused()) {
					// 		parser.resume();
					// 		console.log("chunk", chunk);
					// 	}
					// }, 2000);
					return chunk;
				}.bind(this),
				complete: results => {
					console.log("parse complete");
					console.log("file ", file);
					if (!this.errorsInCsv.length) {
						var formData = new FormData();
						formData.append("file", file);
						formData.append("type", "article_master");
						formData.append("outlets", "");
						formData.append("subregions", "");
						formData.append("regions", "7d3c2640-d6e1-4941-a391-fae656753fac");
						formData.append("countries", "");
						csvService.csvFileUpload(formData);
					}
				}
			});
		},
		// doStuff(chunk, parser) {
		// 	setTimeout(() => {
		// 		if (parser.paused()) {
		// 			parser.resume();
		// 			console.log("chunk", chunk);
		// 		}
		// 	}, 2000);
		// },
		processCsvData(chunk, csvName) {
			if (csvName === "Setup User Accounts") {
				// console.log("csvName", csvName);

				this.processUploadLoginAccessAccountSetUpFileData(chunk);
			}
			if (csvName === "Upload Past Sales Data") {
				this.processPastSalesData(chunk);
			}
			if (csvName === "Upload Article Master File") {
				this.processArticleMaster(chunk);
			}

			if (csvName === "BOM") {
				this.processBOMData(chunk);
			}
		},

		processUploadLoginAccessAccountSetUpFileData(
			uploadLoginAccountSetUpData,
			csvName
		) {
			this.dataToShowInTable.data.headings = uploadLoginAccountSetUpData.data.filter(
				(arr, i) => i === 0
			); // putting headings in dataToShowInTable
			console.log(this.dataToShowInTable.data.headings[0].length);
			if (this.dataToShowInTable.data.headings[0].length === 26) {
				console.log(this.dataToShowInTable.data.headings[0].length === 26);
				const rowsArrInTable = this.dataToShowInTable.data.rows;
				uploadLoginAccountSetUpData.data.map((arr, i) => {
					console.log(
						"array in processuploadLoginAccountSetUpData",
						arr.length === 26
					);
					// iterating over arrays in data field of json object returned from papa
					rowsArrInTable.push([]); //creating empty array which will appear as rows in table.
					console.log("i>>>>", i);
					if (i > 0 && arr.length === 26) {
						console.log("arr.length", arr.length);
						// leaving the headings array
						if (arr[0]) {
							this.checkForString(arr[0])
								? rowsArrInTable[i - 1].push({ value: arr[0], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[0], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[1]) {
							this.checkForString(arr[1])
								? rowsArrInTable[i - 1].push({ value: arr[1], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[1], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[2]) {
							this.checkForAlphaNumeric(arr[2])
								? rowsArrInTable[i - 1].push({ value: arr[2], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[2], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: false });
						}
						if (arr[3]) {
							this.checkForAlphaNumeric(arr[3])
								? rowsArrInTable[i - 1].push({ value: arr[3], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[3], isError: true });
							this.find_duplicate_in_array(rowsArrInTable, "3");
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/* E Account type */
						if (arr[4]) {
							this.checkForString(arr[4])
								? rowsArrInTable[i - 1].push({ value: arr[4], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[4], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/* F Store type */
						if (arr[5]) {
							this.checkForString(arr[5])
								? rowsArrInTable[i - 1].push({ value: arr[5], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[5], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: false });
						}
						/* G Name */

						if (arr[6]) {
							this.checkForString(arr[6])
								? rowsArrInTable[i - 1].push({ value: arr[6], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[6], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: false });
						}
						/*H */

						if (arr[7]) {
							this.CheckForValidateEmail(arr[7])
								? rowsArrInTable[i - 1].push({ value: arr[7], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[7], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: false });
						}
						/*I */
						if (arr[8]) {
							this.checkForString(arr[8])
								? rowsArrInTable[i - 1].push({ value: arr[8], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[8], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/* J*/
						if (arr[9]) {
							this.checkForString(arr[9])
								? rowsArrInTable[i - 1].push({ value: arr[9], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[9], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*K*/
						if (arr[10]) {
							this.checkForString(arr[10])
								? rowsArrInTable[i - 1].push({ value: arr[10], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[10], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*L*/
						if (arr[11]) {
							this.checkForString(arr[11])
								? rowsArrInTable[i - 1].push({ value: arr[11], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[11], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*M*/
						if (arr[12]) {
							this.checkForString(arr[12])
								? rowsArrInTable[i - 1].push({ value: arr[12], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[12], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*N */
						if (arr[13]) {
							this.checkForString(arr[13])
								? rowsArrInTable[i - 1].push({ value: arr[13], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[13], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/* o*/
						if (arr[14]) {
							this.checkForString(arr[14])
								? rowsArrInTable[i - 1].push({ value: arr[14], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[14], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*p*/
						if (arr[15]) {
							this.checkForString(arr[15])
								? rowsArrInTable[i - 1].push({ value: arr[15], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[15], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/* Q*/
						if (arr[16]) {
							this.checkForString(arr[16])
								? rowsArrInTable[i - 1].push({ value: arr[16], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[16], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/* R*/
						if (arr[17]) {
							this.checkForString(arr[17])
								? rowsArrInTable[i - 1].push({ value: arr[17], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[17], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*S */
						if (arr[18]) {
							this.checkForString(arr[18])
								? rowsArrInTable[i - 1].push({ value: arr[18], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[18], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*T*/
						if (arr[19]) {
							this.checkForString(arr[19])
								? rowsArrInTable[i - 1].push({ value: arr[19], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[19], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*U */
						if (arr[20]) {
							this.checkForString(arr[20])
								? rowsArrInTable[i - 1].push({ value: arr[20], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[20], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/* V */
						if (arr[21]) {
							this.checkForString(arr[21])
								? rowsArrInTable[i - 1].push({ value: arr[21], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[21], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*W */
						if (arr[22]) {
							this.checkForString(arr[22])
								? rowsArrInTable[i - 1].push({ value: arr[22], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[22], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*X*/
						if (arr[23]) {
							this.checkForString(arr[23])
								? rowsArrInTable[i - 1].push({ value: arr[23], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[23], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*y*/
						if (arr[24]) {
							this.checkForString(arr[24])
								? rowsArrInTable[i - 1].push({ value: arr[24], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[24], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						/*Z*/
						if (arr[25]) {
							this.checkForString(arr[25])
								? rowsArrInTable[i - 1].push({ value: arr[25], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[25], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
							console.log("rowsArrInTable", rowsArrInTable);
						}
					}
				});
				console.log(uploadLoginAccountSetUpData);
				this.setup_account_csv_file = Papa.unparse(uploadLoginAccountSetUpData);
				console.log("csv", this.setup_account_csv_file);
				this.openDialogforErrors(this.dataToShowInTable, csvName);
			} else {
				this.showCorrectFileSelectMessage();
			}

			// this.dialogVisible = true;
		},

		processPastSalesData(salesData, csvName) {
			// convert each column in a csv file into a array and validate every value of the array
			this.dataToShowInTable.data.headings = salesData.data.filter(
				(arr, i) => i === 0
			); // putting headings in dataToShowInTable
			if (this.dataToShowInTable.data.headings[0].length === 8) {
				const rowsArrInTable = this.dataToShowInTable.data.rows;
				salesData.data.map((arr, i) => {
					console.log("array in processSalesData", arr.length === 8);
					// iterating over arrays in data field of json object returned from papa

					rowsArrInTable.push([]); //creating empty array which will appear as rows in table.
					// console.log("i>>>>", i);
					if (i > 0 && arr.length === 8) {
						console.log("arr.length === 8", arr.length);
						// leaving the headings array
						if (arr[0]) {
							this.checkForDate(arr[0])
								? rowsArrInTable[i - 1].push({ value: arr[0], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[0], isError: true });
						} // if date is correct isError value is false else true for date field in the table
						else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[1]) {
							this.checkForTime(arr[1])
								? rowsArrInTable[i - 1].push({ value: arr[1], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[1], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}

						if (arr[2]) {
							this.checkForAlphaNumeric(arr[2])
								? rowsArrInTable[i - 1].push({ value: arr[2], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[2], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}

						if (arr[3]) {
							this.checkForString(arr[3])
								? rowsArrInTable[i - 1].push({ value: arr[3], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[3], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}

						if (arr[4]) {
							this.checkForString(arr[4])
								? rowsArrInTable[i - 1].push({ value: arr[4], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[4], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}

						if (arr[5]) {
							this.checkForAlphaNumeric(arr[5])
								? rowsArrInTable[i - 1].push({ value: arr[5], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[5], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}

						if (arr[6]) {
							isNaN(arr[6]) || arr[6] < 0
								? rowsArrInTable[i - 1].push({ value: arr[6], isError: true })
								: rowsArrInTable[i - 1].push({ value: arr[6], isError: false });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}

						if (arr[7]) {
							!Number.isInteger(arr[7]) || arr[7] < 0
								? rowsArrInTable[i - 1].push({ value: arr[7], isError: true })
								: rowsArrInTable[i - 1].push({ value: arr[7], isError: false });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
					}
				});
				this.past_sales_csv_file = Papa.unparse(salesData);
				this.openDialogforErrors(this.dataToShowInTable, csvName);
			} else {
				this.showCorrectFileSelectMessage();
			}
		},

		processArticleMaster(chunk) {
			if (!chunk.errors.length) {
				const headings = chunk.meta.fields;
				const status = this.checkHeadingsEquality(
					headings,
					Headings.articleMaster
				);
				console.log("is headings same", status);
				if (status) {
					const data = chunk.data;
					data.map((row, rowIndex, articleMasterArray) => {
						// console.log("data in article master", data);
						/*A 	Article code */
						if (row.hasOwnProperty("Article code") && row["Article code"]) {
							const uniqueArticleCodeValue = String(
								row["Article code"]
							).hashCode();
							if (!this.checkForAlphaNumeric(row["Article code"])) {
								this.errorsInCsv.push({
									value: `value not alpha numeric at row: ${rowIndex +
										1}, Column: Article Code`
								});
							}
							if (
								!this.articleCodeUniqueValueCheck.hasOwnProperty(
									uniqueArticleCodeValue
								)
							) {
								this.articleCodeUniqueValueCheck[uniqueArticleCodeValue] = null;
							} else {
								this.errorsInCsv.push({
									value: `value not unique at row: ${rowIndex +
										1}, Column: Article Code`
								});
							}
						}

						if (
							row.hasOwnProperty("Article Description") &&
							row["Article Description"]
						) {
							if (!this.checkForString(row["Article Description"])) {
								this.errorsInCsv.push({
									value: `value not string at row: ${rowIndex +
										1}, Column: Article Description`
								});
							}
						}

						if (row.hasOwnProperty("Article Type")) {
							const actualValues = [
								"sku",
								"raw material",
								"serveware",
								"consumable",
								"cleaning",
								"equipment",
								"miscellaneous"
							];
							if (row["Article Type"]) {
								const lowerCaseVal = row["Article Type"].toLowerCase();
								if (!actualValues.some(val => lowerCaseVal == val)) {
									this.errorsInCsv.push({
										value: `value should be one of [sku, raw material] at row: ${rowIndex +
											1}, Column: Article Type`
									});
								}
							}
							if (!row["Article Type"]) {
								this.errorsInCsv.push({
									value: `value can't be empty at row: ${rowIndex +
										1}, Column: Article Type`
								});
							}
						}

						if (row.hasOwnProperty("Department")) {
							if (row["Department"]) {
								if (!this.checkForString(row["Department"])) {
									this.errorsInCsv.push({
										value: `value should be a string at row: ${rowIndex +
											1}, Column: Department`
									});
								}
							}
							if (!row["Department"]) {
								this.errorsInCsv.push({
									value: `value can't be empty at row: ${rowIndex +
										1}, Column: Department`
								});
							}
						}

						if (row.hasOwnProperty("Category")) {
							row["Category"]
								? (this.CategoryCheckInAM.full = true)
								: (this.CategoryCheckInAM.empty = true);
							if (
								this.CategoryCheckInAM.full &&
								this.CategoryCheckInAM.empty &&
								rowIndex == articleMasterArray.length - 1
							) {
								this.errorsInCsv.push({
									value: `all values in column Category should be either filled or empty`
								});
							}
							if (row["Category"]) {
								if (!this.checkForString(row["Category"])) {
									this.errorsInCsv.push({
										value: `value should be a string at row: ${rowIndex +
											1}, Column: Category`
									});
								}
							}
						}

						if (row.hasOwnProperty("Sub Category")) {
							row["Sub Category"]
								? (this.SubCategoryCheckInAM.full = true)
								: (this.SubCategoryCheckInAM.empty = true);
							if (
								this.SubCategoryCheckInAM.full &&
								this.SubCategoryCheckInAM.empty &&
								rowIndex == articleMasterArray.length - 1
							) {
								this.errorsInCsv.push({
									value: `all values in column Sub Category should be either filled or empty`
								});
							}
							if (row["Sub Category"]) {
								if (!this.checkForString(row["Sub Category"])) {
									this.errorsInCsv.push({
										value: `value should be a string at row: ${rowIndex +
											1}, Column: Sub Category`
									});
								}
							}
						}

						if (row.hasOwnProperty("Service Level")) {
							// console.log("na", row["Service Level"].toLowerCase());
							if (
								row["Service Level"] &&
								isNaN(row["Service Level"]) &&
								row["Service Level"].toLowerCase() != "n/a"
							) {
								this.errorsInCsv.push({
									value: `value should be a integer or n/a at row: ${rowIndex +
										1}, Column: Service Level`
								});
							}
							if (!row["Service Level"]) {
								this.errorsInCsv.push({
									value: `value should be a integer or n/a at row: ${rowIndex +
										1}, Column: Service Level`
								});
							}
						}

						if (row.hasOwnProperty("Sales Price")) {
							if (row["Sales Price"] && isNaN(row["Sales Price"])) {
								this.errorsInCsv.push({
									value: `value should be a integer  at row: ${rowIndex +
										1}, Column: Sales Price`
								});
							}
							if (!row["Sales Price"]) {
								this.errorsInCsv.push({
									value: `value can't be empty at row: ${rowIndex +
										1}, Column: Sales Price`
								});
							}
						}
					});
				}
			}

			// this.dataToShowInTable.data.headings = uploadArticleMasterFileData.data.filter(
			// 	(arr, i) => i === 0
			// ); // putting headings in dataToShowInTable
			// if (this.dataToShowInTable.data.headings[0].length === 35) {
			// 	const rowsArrInTable = this.dataToShowInTable.data.rows;
			// 	uploadArticleMasterFileData.data.map((arr, i) => {
			// 		console.log(
			// 			"array in processuploadArticleMasterFileData",
			// 			arr.length === 35
			// 		);
			// 		// iterating over arrays in data field of json object returned from papa

			// 		rowsArrInTable.push([]); //creating empty array which will appear as rows in table.
			// 		// console.log("i>>>>", i);
			// 		if (i > 0 && arr.length === 35) {
			// 			// leaving the headings array

			// 			/*A 	Account ID */
			// 			if (arr[0]) {
			// 				this.checkForAlphaNumeric(arr[0])
			// 					? rowsArrInTable[i - 1].push({ value: arr[0], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[0], isError: true });
			// 				this.find_duplicate_in_array(rowsArrInTable, "0");
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*B  Article code numeric and unique id*/
			// 			if (arr[1]) {
			// 				!Number.isInteger(arr[1]) || arr[1] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[1], isError: true })
			// 					: rowsArrInTable[i - 1].push({ value: arr[1], isError: false });
			// 				this.find_duplicate_in_array(rowsArrInTable, "1");
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}

			// 			/*C  alphanumeric and unique name*/

			// 			if (arr[2]) {
			// 				this.checkForAlphaNumeric(arr[2])
			// 					? rowsArrInTable[i - 1].push({ value: arr[2], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[2], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}

			// 			/* D Ingridient Type Characters*/

			// 			if (arr[3]) {
			// 				this.checkForString(arr[3])
			// 					? rowsArrInTable[i - 1].push({ value: arr[3], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[3], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/* E Department Alpha numeric */
			// 			if (arr[4]) {
			// 				this.checkForAlphaNumeric(arr[4])
			// 					? rowsArrInTable[i - 1].push({ value: arr[4], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[4], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/* F Category  Alpha numeric  */
			// 			if (arr[5]) {
			// 				this.checkForAlphaNumeric(arr[5])
			// 					? rowsArrInTable[i - 1].push({ value: arr[5], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[5], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}

			// 			/* G SubCategory  Alpha numeric */
			// 			if (arr[6]) {
			// 				this.checkForAlphaNumeric(arr[6])
			// 					? rowsArrInTable[i - 1].push({ value: arr[6], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[6], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}

			// 			/*H Order Unit Characters */
			// 			if (arr[7]) {
			// 				this.checkForAlphaNumeric(arr[7])
			// 					? rowsArrInTable[i - 1].push({ value: arr[7], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[7], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}

			// 			/* I Contains Each Numerical with decimal*/
			// 			if (arr[8]) {
			// 				isNaN(arr[8]) || arr[8] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[8], isError: true })
			// 					: rowsArrInTable[i - 1].push({ value: arr[8], isError: false });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/* J issue unit Characters  */
			// 			if (arr[9]) {
			// 				this.checkForString(arr[9])
			// 					? rowsArrInTable[i - 1].push({ value: arr[9], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[9], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*K  Contains Each Numeric with decimal */
			// 			if (arr[10]) {
			// 				!Number.isInteger(arr[10]) || arr[10] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[10], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[10],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}

			// 			/* L Base unit characters*/
			// 			if (arr[11]) {
			// 				this.checkForBaseUnit(arr[11])
			// 					? rowsArrInTable[i - 1].push({ value: arr[11], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[11], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}

			// 			/* M Primary self life Numeric*/
			// 			if (arr[12]) {
			// 				!Number.isInteger(arr[12]) || arr[12] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[12], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[12],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/* N  Secondary Shelf life Numric */
			// 			if (arr[13]) {
			// 				!Number.isInteger(arr[13]) || arr[13] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[13], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[13],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*O Standard deviation of Sales/ dispatch Qty  not given */
			// 			if (arr[14]) {
			// 				this.checkForString(arr[14])
			// 					? rowsArrInTable[i - 1].push({ value: arr[14], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[14], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*p Ordering Frequency Numeric */
			// 			if (arr[15]) {
			// 				!Number.isInteger(arr[15]) || arr[15] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[15], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[15],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*Q Final Class characters*/
			// 			if (arr[16]) {
			// 				this.checkForString(arr[16])
			// 					? rowsArrInTable[i - 1].push({ value: arr[16], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[16], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/* R Type Of Forecast not given */
			// 			if (arr[17]) {
			// 				this.checkForAlphaNumeric(arr[17])
			// 					? rowsArrInTable[i - 1].push({ value: arr[17], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[17], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}

			// 			/* $ Approx Lead Time in Days numeric*/
			// 			if (arr[18]) {
			// 				isNaN(arr[18]) || arr[18] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[18], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[18],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*T Service Level percentage  */
			// 			if (arr[19]) {
			// 				isNaN(arr[19]) || arr[19] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[19], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[19],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*U MAP Nmerical*/
			// 			if (arr[20]) {
			// 				!Number.isInteger(arr[20]) || arr[20] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[20], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[20],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}

			// 			/*v Current Cost numerical with decimals*/
			// 			if (arr[21]) {
			// 				isNaN(arr[21]) || arr[21] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[21], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[21],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*w  Sales Price numerical with decimals*/
			// 			if (arr[22]) {
			// 				isNaN(arr[22]) || arr[22] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[22], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[22],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/* x Product Remarks characters*/
			// 			if (arr[23]) {
			// 				this.checkForString(arr[23])
			// 					? rowsArrInTable[i - 1].push({ value: arr[23], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[23], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/* Y Stock Comes from alpha numeric*/
			// 			if (arr[24]) {
			// 				this.checkForAlphaNumeric(arr[24])
			// 					? rowsArrInTable[i - 1].push({ value: arr[24], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[24], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*Z Vendor name alphanumeric*/
			// 			if (arr[25]) {
			// 				this.checkForAlphaNumeric(arr[25])
			// 					? rowsArrInTable[i - 1].push({ value: arr[25], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[25], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*AA Vendor code alphanumeric*/
			// 			if (arr[26]) {
			// 				this.checkForAlphaNumeric(arr[26])
			// 					? rowsArrInTable[i - 1].push({ value: arr[26], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[26], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*AB vendor address alphanumeric*/
			// 			if (arr[27]) {
			// 				this.checkForAlphaNumeric(arr[27])
			// 					? rowsArrInTable[i - 1].push({ value: arr[27], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[27], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*AC vedor phone numeric*/
			// 			if (arr[28]) {
			// 				!Number.isInteger(arr[28]) || arr[28] < 0
			// 					? rowsArrInTable[i - 1].push({ value: arr[28], isError: true })
			// 					: rowsArrInTable[i - 1].push({
			// 							value: arr[28],
			// 							isError: false
			// 					  });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*AD vendor email email format*/
			// 			if (arr[29]) {
			// 				this.CheckForValidateEmail(arr[29])
			// 					? rowsArrInTable[i - 1].push({ value: arr[29], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[29], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*AE Created on date*/
			// 			if (arr[30]) {
			// 				this.checkForDate(arr[30])
			// 					? rowsArrInTable[i - 1].push({ value: arr[30], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[30], isError: true });
			// 			} // if date is correct isError value is false else true for date field in the table
			// 			else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*AF Created by characters*/
			// 			if (arr[31]) {
			// 				this.checkForString(arr[31])
			// 					? rowsArrInTable[i - 1].push({ value: arr[31], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[31], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*AG Last change date*/
			// 			if (arr[32]) {
			// 				this.checkForDate(arr[32])
			// 					? rowsArrInTable[i - 1].push({ value: arr[32], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[32], isError: true });
			// 			} // if date is correct isError value is false else true for date field in the table
			// 			else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*AH changed by characters*/
			// 			if (arr[33]) {
			// 				this.checkForString(arr[33])
			// 					? rowsArrInTable[i - 1].push({ value: arr[33], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[33], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 			/*AI Status characters*/
			// 			if (arr[34]) {
			// 				this.checkForActiveInactive(arr[34])
			// 					? rowsArrInTable[i - 1].push({ value: arr[34], isError: false })
			// 					: rowsArrInTable[i - 1].push({ value: arr[34], isError: true });
			// 			} else {
			// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
			// 			}
			// 		}
			// 	});
			// 	this.article_master_csv_file = Papa.unparse(
			// 		uploadArticleMasterFileData
			// 	);
			// 	console.log("csv", this.article_master_csv_file);
			// 	this.openDialogforErrors(this.dataToShowInTable, csvName);
			// } else {
			// 	this.showCorrectFileSelectMessage();
			// }
		},

		processBOMData(BOMData, csvName) {
			this.dataToShowInTable.data.headings = BOMData.data.filter(
				(arr, i) => i === 0
			); // putting headings in dataToShowInTable
			if (this.dataToShowInTable.data.headings[0].length === 12) {
				const rowsArrInTable = this.dataToShowInTable.data.rows;
				BOMData.data.map((arr, i) => {
					console.log("array in processBOMData", arr.length === 12);
					// iterating over arrays in data field of json object returned from papa

					rowsArrInTable.push([]); //creating empty array which will appear as rows in table.
					// console.log("i>>>>", i);
					if (i > 0 && arr.length === 12) {
						// leaving the headings array
						if (arr[0]) {
							this.checkForAlphaNumeric(arr[0])
								? rowsArrInTable[i - 1].push({ value: arr[0], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[0], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[1]) {
							this.checkForAlphaNumeric(arr[1])
								? rowsArrInTable[i - 1].push({ value: arr[1], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[1], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[2]) {
							this.checkForAlphaNumeric(arr[2])
								? rowsArrInTable[i - 1].push({ value: arr[2], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[2], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[3]) {
							this.checkForAlphaNumeric(arr[3])
								? rowsArrInTable[i - 1].push({ value: arr[3], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[3], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[4]) {
							this.checkForAlphaNumeric(arr[4])
								? rowsArrInTable[i - 1].push({ value: arr[4], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[4], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[5]) {
							!Number.isInteger(arr[5]) || arr[5] < 0
								? rowsArrInTable[i - 1].push({ value: arr[5], isError: true })
								: rowsArrInTable[i - 1].push({ value: arr[5], isError: false });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[6]) {
							this.checkForAlphaNumeric(arr[6])
								? rowsArrInTable[i - 1].push({ value: arr[6], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[6], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[7]) {
							this.checkForAlphaNumeric(arr[7])
								? rowsArrInTable[i - 1].push({ value: arr[7], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[7], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[8]) {
							this.checkForAlphaNumeric(arr[8])
								? rowsArrInTable[i - 1].push({ value: arr[8], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[8], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[9]) {
							this.checkForAlphaNumeric(arr[9])
								? rowsArrInTable[i - 1].push({ value: arr[9], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[9], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[10]) {
							this.checkForFloat(arr[10])
								? rowsArrInTable[i - 1].push({ value: arr[10], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[10], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
						if (arr[11]) {
							this.checkForBaseUnit(arr[11])
								? rowsArrInTable[i - 1].push({ value: arr[11], isError: false })
								: rowsArrInTable[i - 1].push({ value: arr[11], isError: true });
						} else {
							rowsArrInTable[i - 1].push({ value: null, isError: true });
						}
					}
				});
				this.bom_csv_file = Papa.unparse(BOMData);
				console.log("csv", this.bom_csv_file);
				this.openDialogforErrors(this.dataToShowInTable, csvName);
				console.log("this.dataToShowInTable", this.dataToShowInTable);
			} else {
				this.showCorrectFileSelectMessage();
			}
			// this.dialogVisible = true;
		},

		checkForUniqueInt(val) {
			var re = new RegExp(/\b((?!CR|cr)[A-Za-z]{2}\d{5,6})\b(?![\s\S]*\b\1\b)/);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForDate(val) {
			var re = new RegExp(
				/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/
			);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForTime(val) {
			var re = new RegExp(
				/^(((([0-1][0-9])|(2[0-3])):[0-5][0-9](:[0-5][0-9])?)|(24:00(:00)?))$/
			);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForAlphaNumeric(val) {
			// if val is alphaNumeric then function returns true else returns false
			var re = new RegExp(/^[a-zA-Z0-9_ ]+$/);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForFloat(val) {
			var re = new RegExp(/(\d+(\.\d+)?)/);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForBaseUnit(val) {
			var re = new RegExp(/^[a-zA-Z]+$/);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		CheckForValidateEmail(val) {
			var re = new RegExp(
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
			// return re.test(String(email).toLowerCase());
		},
		checkForActiveInactive(val) {
			if (val === "Active " || val === "Active" || val === "Inactive") {
				console.log("true");
				return true;
			} else {
				console.log("false");
				return false;
			}
		},
		checkForString(str) {
			return typeof str === "string";
		},
		openDialogforErrors(dataToShowInTable, csvName) {
			this.current_open_file = csvName;
			console.log("this.dataToShowInTable", dataToShowInTable);
			var count_errors = [];
			if (dataToShowInTable) {
				for (var i in dataToShowInTable.data.rows) {
					for (var j in dataToShowInTable.data.rows[i]) {
						if (dataToShowInTable.data.rows[i][j].isError === true) {
							count_errors.push(j);
						}
					}
				}
			}
			if (csvName == "Setup User Accounts") {
				if (count_errors.length == 0) {
					if (csvName == "Setup User Accounts") {
						console.log("csvName", csvName);
						this.upload_setup_user_account_visible = true;
					}
					this.setup_user_account = dataToShowInTable;
					this.$notify.success({
						title: "Success",
						message: "Success",
						type: "success"
					});
					this.dataToShowInTable = {
						data: {
							headings: [],
							rows: []
						}
					};
				} else {
					if (csvName == "Setup User Accounts") {
						this.upload_setup_user_account_visible = false;
					}
					this.dialogVisible = true;
					console.log("errors");
					this.$notify.error({
						title: "Error",
						message: "Errors in CSV file",
						type: "error"
					});
				}
			}
			if (csvName == "Upload Past Sales Data") {
				if (count_errors.length == 0) {
					if (csvName == "Upload Past Sales Data") {
						console.log("csvName", csvName);
						this.upload_past_sales_visible = true;
					}
					console.log("upload_article_master_file", dataToShowInTable);
					// this.csv_file = Papa.unparse(dataToShowInTable);
					this.csv_file = Papa.unparse(this.past_sales_file);
					console.log("upload_article_master_file", this.csv_file);
					this.$notify.success({
						title: "Success",
						message: "Success",
						type: "success"
					});
					this.dataToShowInTable = {
						data: {
							headings: [],
							rows: []
						}
					};
				} else {
					if (csvName == "Upload Past Sales Data") {
						this.upload_past_sales_visible = false;
					}
					this.dialogVisible = true;
					console.log("errors");
					this.$notify.error({
						title: "Error",
						message: "Errors in CSV file",
						type: "error"
					});
				}
			}

			if (csvName == "Upload Article Master File") {
				if (count_errors.length == 0 && this.check_duplicate_data == false) {
					if (csvName == "Upload Article Master File") {
						this.upload_art_master_visible = true;
					}
					// this.upload_article_master_file = dataToShowInTable;
					this.$notify.success({
						title: "Success",
						message: "Success",
						type: "success"
					});
					this.dataToShowInTable = {
						data: {
							headings: [],
							rows: []
						}
					};
				} else {
					if (csvName == "Upload Article Master File") {
						this.upload_art_master_visible = false;
					}
					this.dialogVisible = true;
					console.log("errors");
					this.$notify.error({
						title: "Error",
						message: "Errors in CSV file",
						type: "error"
					});
				}
			}

			if (csvName == "BOM") {
				if (count_errors.length == 0) {
					if (csvName == "BOM") {
						console.log("csvName", csvName);
						this.upload_BOM_visible = true;
					}
					this.upload_BOM_file = dataToShowInTable;
					this.$notify.success({
						title: "Success",
						message: "Success",
						type: "success"
					});
					this.dataToShowInTable = {
						data: {
							headings: [],
							rows: []
						}
					};
				} else {
					if (csvName == "BOM") {
						this.upload_BOM_visible = false;
					}
					this.dialogVisible = true;
					console.log("errors");
					this.$notify.error({
						title: "Error",
						message: "Errors in CSV file",
						type: "error"
					});
				}
			}
		},
		showCorrectFileSelectMessage() {
			this.$notify.error({
				title: "Error",
				message: "Select correct CSV file",
				type: "error"
			});
		},
		submitCSVFile() {
			serverAddr
				.post("/company/setup/upload/setupfile", {})
				.then(this.postFinishSetUpNC)
				.catch(error => {
					this.$notify.error({
						title: "Error",
						// message: JSON.parse(error.response.data).user.email[0],
						message:
							"This email id already exists. Please sign up with a different email id",
						type: "Error"
					});
				});
		},
		checkHeadingsEquality(a, b) {
			console.log("a", a, "b", b);
			if (this.arraysEqual(a, b)) {
				return true;
			} else {
				this.errorsInCsv.push({ value: "Headings", isError: true });
				return false;
			}
		},
		arraysEqual(a, b) {
			if (a === b) return true;
			if (a == null || b == null) return false;
			if (a.length != b.length) return false;

			// If you don't care about the order of the elements inside
			// the array, you should sort both arrays here.
			// Please note that calling sort on an array will modify that array.
			// you might want to clone your array first.

			for (var i = 0; i < a.length; ++i) {
				if (a[i] !== b[i]) return false;
			}
			return true;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./AccountSetupV2.scss";
@import "../../components/admin/appTable/AppTable.scss";
@import "../../assets/css/variable.scss";
</style>
<style>
.file-green-icon {
	padding: 1px !important;
	margin-right: 0.5rem !important;
	color: #0dac50 !important;
}
.file-grey-icon {
	padding: 1px !important;
	color: #ccc !important;
	border-color: #ccc !important;
	margin-right: 0.5rem !important;
}
.el-notification {
	z-index: 9999 !important;
}
.inputfile + label {
	font-size: 1.25em;
	font-weight: 700;
	color: white;
	background-color: black;
	display: inline-block;
}

.inputfile:focus + label,
.inputfile + label:hover {
	background-color: red;
}
</style>
